<template>
  <div>
    <v-snackbar
      v-for="(item, i) in configurations"
      :key="item.id.toString()"
      v-bind="$attrs"
      :value="i === 0"
      :top="item.position === 'top'"
      :timeout="item.timeout"
      :color="item.type?.colour"
    >
      {{ item.text }}
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import type Guid from "@/app/types/common/guid";
import type { PropType } from "vue";
import { defineComponent, ref, watch } from "vue";
import type { SnackbarConfiguration } from "@/components/controls/snackbar/SnackbarTypes";
import type { ReadonlyEntityArray } from "@/components/composables/reactivityTypes";

/**
 * Based on `vuetify-snackbar-queue`
 * https://github.com/ajanes93/vuetify-snackbar-queue
 *
 * @description Wrapper component for VSnackbar that supports queuing
 * functionality
 */
export default defineComponent({
  name: "BmQueuedSnackbar",
  inheritAttrs: false,
  props: {
    configurations: {
      type: Array as PropType<ReadonlyEntityArray<SnackbarConfiguration>>,
      required: false,
      default: () => [],
    },
  },
  emits: ["remove"],
  setup(props, context) {
    const currentTimeout = ref<number | null>(null);

    function processConfigurations(): any {
      if (props.configurations.length > 0) {
        const item = props.configurations[0];

        // if we aren't currently dealing with a timeout
        if (!currentTimeout.value) {
          return (currentTimeout.value = +setTimeout(
            () => removeConfiguration(item.id),
            item.timeout
          ));
        }
      }
    }

    function removeConfiguration(id: Guid): any {
      currentTimeout.value = null;

      context.emit("remove", id);

      if (props.configurations.length > 0) {
        return processConfigurations();
      }
    }

    watch(() => props.configurations, processConfigurations);

    return {};
  },
});
</script>
